<template>
  <div class="campaign-charts">
    <LineChart
      v-if="campaign.balanceTable?.labels"
      :chartData="campaign.balanceTable"
      :options="chartOptions"/>
    <div class="deverative-calculator">
      <h4>Calculate Derivative</h4>
      <select v-model="selectedDatasetIdx">
        <option v-for="(ds, idx) in campaign.balanceTable.datasets" :key="idx" :value="idx">
          {{ ds.label }}
        </option>
      </select>
      <input type="date" v-model="slopeStart" :min="minDate" :max="maxDate">
      <input type="date" v-model="slopeEnd" :min="minDate" :max="maxDate">
      <div v-if="slopeTotal !== null">
        Derivative: {{ slopeTotal.toFixed(2) }} {{ campaign.cashback_currency }} per day
      </div>
    </div>
  </div>
</template>

<script>
import { Line } from 'vue-chartjs';
// vue-chartjs/legacy

export default {
  name: "CashbackList",
  components: {
    LineChart: Line,
  },
  props: {
    admin: {
      type: Boolean,
      default: false,
    },
    campaign: {
      type: Object,
      required: true,
    },
  },
  computed: {
    minDate() {
      return this.campaign.balanceTable?.labels?.[0] || '';
    },
    maxDate() {
      const labels = this.campaign.balanceTable?.labels;
      return labels ? labels[labels.length - 1] : '';
    },
    slopeTotal() {
      if (!this.campaign.balanceTable) {
        return null;
      }
      const idx = this.selectedDatasetIdx ?? 0;
      return this.getSlope(
        this.campaign.balanceTable.datasets[idx].data,
        this.campaign.balanceTable.labels,
        this.slopeStart,
        this.slopeEnd
      );
    },
    chartOptions() {
      return {};
    }
  },
  watch: {
    campaign: {
      handler(newVal, oldVal) {
        if (newVal._id !== oldVal._id) {
          this.setSlopeDates();
        }
      },
      deep: true,
    },
  },
  mounted() {
    this.setSlopeDates();
  },
  data() {
    return {
      slopeStart: null,
      slopeEnd: null,
      selectedDatasetIdx: 0,
    };
  },
  methods: {
    setSlopeDates() {
      if (this.campaign.balanceTable?.labels) {
        this.slopeStart = this.campaign.balanceTable.labels[0];
        this.slopeEnd = this.campaign.balanceTable.labels[this.campaign.balanceTable.labels.length - 1];
      }
    },
    getSlope(data, labels, startDate, endDate) {
      // Find indices for the selected dates
      const startIdx = labels.indexOf(startDate);
      const endIdx = labels.indexOf(endDate);

      if (startIdx === -1 || endIdx === -1 || endIdx <= startIdx) return null;

      const deltaY = data[endIdx] - data[startIdx];
      const deltaX = endIdx - startIdx; // days

      return deltaY / deltaX;
    },
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "./CampaignCharts.scss";
</style>
